import styled from "styled-components";
import {
  border,
  brand,
  radius,
  spacing,
  surface,
  text,
  typography,
} from "../../theme/tokens";

export const SearchPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  max-width: 720px;
  margin: 0 auto;
  width: 100%;
  background: ${surface.surface};
`;

export const SearchHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2.5]};
  padding: ${spacing[4]} ${spacing[4]} ${spacing[3]};
  border-bottom: 1px solid ${border.light};
  flex-shrink: 0;
`;

export const SearchTitle = styled.h1`
  margin: 0;
  font-size: ${typography.size.lg};
  font-weight: ${typography.weight.bold};
  color: ${text.primary};
`;

export const SearchResultsArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

export const ResultRow = styled.button`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  padding: ${spacing[3]} ${spacing[4]};
  border: none;
  border-bottom: 1px solid ${border.light};
  background: transparent;
  text-align: left;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background: ${surface.hover};
  }

  &:focus-visible {
    outline: 2px solid ${brand.primary};
    outline-offset: -2px;
  }
`;

export const ResultTitle = styled.span`
  font-size: ${typography.size.md};
  font-weight: ${typography.weight.semibold};
  color: ${text.primary};
  word-break: break-word;
`;

export const ResultMeta = styled.span`
  font-size: ${typography.size.sm};
  color: ${text.tertiary};
  word-break: break-word;
`;

export const SearchStatus = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing[2]};
  padding: ${spacing[8]} ${spacing[5]};
  color: ${text.muted};
  font-size: ${typography.size.md};
  text-align: center;
`;

export const LoadMoreButton = styled.button`
  display: block;
  margin: ${spacing[3]} auto ${spacing[4]};
  padding: ${spacing[2]} ${spacing[5]};
  border-radius: ${radius.md};
  border: 1px solid ${border.default};
  background: ${surface.surface};
  color: ${brand.primary};
  font-size: ${typography.size.sm};
  font-weight: ${typography.weight.semibold};
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
